var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" LDX 7.0.0, API "+_vm._s(_vm.apiInfo.version)+" - "+_vm._s(_vm.apiInfo.commitHash)+", UI "+_vm._s(_vm.uiInfo.version)+" - "+_vm._s(_vm.uiInfo.commitHash)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }